var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCrowdvotingFoerdersummenVisualisierungInlineRgb = function SvgCrowdvotingFoerdersummenVisualisierungInlineRgb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 520.72,
    height: 240,
    viewBox: "0 0 520.72 240",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M175.35,69.42v4.3c0,3.26-.24,5.76-4.77,8.69l-8.45,5.24c-1.42.8-1.89,1.42-1.89,2.64v.85h15.29c.33,0,.38.05.38.28v5.95c0,.24-.09.28-.33.28h-24.26c-1.04,0-1.28-.52-1.28-1.32v-4.25c0-3.96,1.65-5.62,6-8.59l10.05-6.61c1.56-1.04,1.84-2.27,1.84-4.3v-1.6c0-2.97-2.03-3.68-6.61-3.68h-9.16c-.38,0-.57-.14-.57-.52v-4.06c0-.66.28-.9.9-1.04,3.02-.57,5.1-.85,9.63-.85,6.94,0,13.22,1.18,13.22,8.59Z",
    style: {
      fill: "#ffd43e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.21,79.43c0,14.3-2.74,18.46-13.97,18.46s-14.02-4.15-14.02-18.46,2.74-18.6,14.02-18.6,13.97,4.3,13.97,18.6ZM187.67,79.43c0,9.25,1.27,11.99,6.56,11.99s6.51-2.74,6.51-11.99-1.27-12.13-6.51-12.13-6.56,2.83-6.56,12.13Z",
    style: {
      fill: "#ffd43e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.74,79.43c0,14.3-2.74,18.46-13.97,18.46s-14.02-4.15-14.02-18.46,2.74-18.6,14.02-18.6,13.97,4.3,13.97,18.6ZM220.2,79.43c0,9.25,1.27,11.99,6.56,11.99s6.51-2.74,6.51-11.99-1.27-12.13-6.51-12.13-6.56,2.83-6.56,12.13Z",
    style: {
      fill: "#ffd43e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.08,61.77c.57.19.85.42.85.85v3.82c0,.61-.28.85-.9.85h-11.19c-2.88,0-4.34.99-4.34,3.07v.66c0,1.65.66,2.74,2.78,3.54l8.83,3.45c4.53,1.79,6.56,4.01,6.56,9.49v1.32c0,6.99-5.43,9.06-13.59,9.06-3.49,0-7.22-.28-11.66-.99-.61-.14-.8-.42-.8-1.04v-3.59c0-.57.28-.85.9-.85h13.41c2.83,0,4.3-.85,4.3-2.93v-.61c0-2.03-.94-2.97-3.4-3.92l-9.21-3.45c-3.92-1.46-5.62-4.15-5.62-9.63v-1.04c0-6.99,4.86-9.02,13.22-9.02,3.92,0,6.18.28,9.86.94Z",
    style: {
      fill: "#ffd43e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.53,63.9c.47-.14.76.19.76.71v6.75h4.34c.52,0,.8.24.8.71v3.78c0,.47-.28.71-.8.71h-4.34v12.89c0,2.03.71,2.41,2.78,2.41h1.94c.57,0,.8.19.8.71v4.01c0,.57-.24.8-.76.9-1.65.33-2.97.43-4.01.43-4.06,0-7.74-.14-7.74-6.09v-15.25h-2.78c-.52,0-.76-.24-.76-.71v-3.78c0-.47.24-.71.76-.71h2.78v-5.24c0-.47.19-.66.66-.76l5.57-1.46Z",
    style: {
      fill: "#ffd43e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.19,63.85c0,2.41-1.46,3.82-4.06,3.82s-4.15-1.42-4.15-3.82,1.51-3.78,4.15-3.78,4.06,1.37,4.06,3.78ZM308.86,71.21c.47,0,.71.24.71.71v24.97c0,.52-.24.76-.71.76h-5.57c-.47,0-.71-.24-.71-.76v-24.97c0-.47.24-.71.71-.71h5.57Z",
    style: {
      fill: "#ffd43e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.63,80.98l-.05,15.91c0,.52-.24.76-.71.76h-5.57c-.47,0-.71-.24-.71-.76v-12.79c0-6.75-.71-7.08-4.48-7.08-1.27,0-2.64.09-3.82.28.42,1.27.61,2.88.61,5l-.05,14.59c0,.52-.19.76-.66.76h-5.62c-.47,0-.66-.24-.66-.76v-14.4c-.05-5.24-.9-5.48-4.53-5.48h-3.21v19.87c0,.52-.24.76-.71.76h-5.57c-.47,0-.71-.24-.71-.76v-24.4c0-.52.19-.61.61-.71,2.6-.57,6.61-.8,9.06-.8,3.63,0,6.7.66,8.45,1.51,2.6-.99,5.81-1.56,8.21-1.56,7.36,0,10.1,2.08,10.1,10.05Z",
    style: {
      fill: "#ffd43e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.51,80.98l-.05,15.91c0,.52-.24.76-.71.76h-5.57c-.47,0-.71-.24-.71-.76v-12.79c0-6.75-.71-7.08-4.48-7.08-1.27,0-2.64.09-3.82.28.42,1.27.61,2.88.61,5l-.05,14.59c0,.52-.19.76-.66.76h-5.62c-.47,0-.66-.24-.66-.76v-14.4c-.05-5.24-.9-5.48-4.53-5.48h-3.21v19.87c0,.52-.24.76-.71.76h-5.57c-.47,0-.71-.24-.71-.76v-24.4c0-.52.19-.61.61-.71,2.6-.57,6.61-.8,9.06-.8,3.63,0,6.7.66,8.45,1.51,2.6-.99,5.81-1.56,8.21-1.56,7.36,0,10.1,2.08,10.1,10.05Z",
    style: {
      fill: "#ffd43e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.64,84.1v1.46c0,.94-.28,1.27-1.51,1.27h-14.82c.09,4.25,1.23,5,5.33,5h8.36c.47,0,.71.24.71.71v3.92c0,.52-.24.71-.66.76-2.5.52-5.9.66-9.02.66-9.54,0-11.85-2.69-11.85-13.45s2.31-13.45,11.85-13.45,11.56,2.6,11.61,13.12ZM405.26,82.26h9.35c-.05-4.15-1.13-5.24-4.58-5.24s-4.72,1.09-4.77,5.24Z",
    style: {
      fill: "#ffd43e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.45,82.3v14.59c0,.52-.28.76-.76.76h-5.57c-.47,0-.71-.24-.71-.76v-12.79c0-6.75-.71-7.08-5.05-7.08h-4.3v19.87c0,.52-.24.76-.71.76h-5.62c-.47,0-.71-.24-.71-.76v-24.4c0-.57.24-.61.71-.71,3.16-.71,7.74-.8,11.28-.8,9.06,0,11.42,1.7,11.42,11.33Z",
    style: {
      fill: "#ffd43e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.93,73c.58,0,.87.29.87.87v6.12c0,.58-.29.87-.87.87h-29.49c-.58,0-.87-.29-.87-.87v-6.12c0-.58.29-.87.87-.87h29.49ZM499.93,88.01c.58,0,.87.29.87.87v6.12c0,.58-.29.87-.87.87h-29.49c-.58,0-.87-.29-.87-.87v-6.12c0-.58.29-.87.87-.87h29.49Z",
    style: {
      fill: "#55c81e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M193.22,133.01v7.4c0,5.61-.41,9.93-8.22,14.97l-14.56,9.03c-2.44,1.38-3.26,2.44-3.26,4.56v1.47h26.36c.57,0,.65.08.65.49v10.25c0,.41-.16.49-.57.49h-41.82c-1.79,0-2.2-.89-2.2-2.28v-7.32c0-6.83,2.85-9.68,10.33-14.81l17.33-11.39c2.68-1.79,3.17-3.91,3.17-7.4v-2.77c0-5.12-3.5-6.35-11.39-6.35h-15.79c-.65,0-.97-.24-.97-.9v-7c0-1.14.49-1.55,1.55-1.79,5.21-.98,8.79-1.47,16.6-1.47,11.96,0,22.78,2.03,22.78,14.81Z",
    style: {
      fill: "#ffd43e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.92,118.69c.81,0,1.22.41,1.22,1.22v8.71c0,.81-.41,1.22-1.22,1.22h-28.07l-1.06,13.18c2.44-.33,6.34-.49,8.3-.49,14.89,0,23.27,3.09,23.35,16.76v6.1c-.08,13.67-8.62,16.68-24.81,16.68-6.35,0-12.86-.41-16.84-1.14-1.22-.24-1.87-.65-1.87-1.87v-7.08c0-.73.41-1.06,1.22-1.06h16.68c10.58,0,12.77-1.95,12.77-8.22v-.65c-.08-6.27-2.2-8.38-12.77-8.38h-15.7c-1.63,0-2.2-.49-2.2-1.63v-7.73l1.95-24.41c.08-.81.41-1.22,1.3-1.22h37.75Z",
    style: {
      fill: "#ffd43e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.08,150.26c0,24.65-4.72,31.81-24.08,31.81s-24.16-7.16-24.16-31.81,4.72-32.06,24.16-32.06,24.08,7.4,24.08,32.06ZM265.69,150.26c0,15.95,2.2,20.67,11.31,20.67s11.23-4.72,11.23-20.67-2.2-20.91-11.23-20.91-11.31,4.88-11.31,20.91Z",
    style: {
      fill: "#ffd43e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.5,118.69c.81,0,1.22.41,1.22,1.22v8.71c0,.81-.41,1.22-1.22,1.22h-29.21v15.38h26.69c.81,0,1.3.41,1.3,1.22v8.3c0,.81-.49,1.22-1.3,1.22h-26.69v14.56h29.21c.81,0,1.22.41,1.22,1.22v8.71c0,.81-.41,1.22-1.22,1.22h-40.76c-.81,0-1.22-.41-1.22-1.3v-60.45c0-.81.41-1.22,1.22-1.22h40.76Z",
    style: {
      fill: "#ffd43e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.14,136.1c.81,0,1.14.41,1.14,1.22v41.98c0,1.06-.32,1.22-1.14,1.38-5.53,1.06-13.42,1.38-19.53,1.38-15.62,0-19.61-2.93-19.61-19.61v-25.14c0-.81.49-1.22,1.3-1.22h9.6c.81,0,1.14.41,1.14,1.22v22.05c0,11.72,1.3,12.29,8.79,12.29h7.32v-34.33c0-.81.41-1.22,1.22-1.22h9.76Z",
    style: {
      fill: "#ffd43e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.34,136.59c.9.24,1.3.57,1.3,1.63v6.67c0,.81-.49,1.22-1.38,1.22h-7.65c-4.23,0-5.7.65-5.7,4.15v30.1c0,.89-.41,1.3-1.22,1.3h-9.68c-.81,0-1.22-.41-1.22-1.3v-33.2c0-10.25,7.32-11.47,14.73-11.47,2.36,0,7.97.24,10.82.9Z",
    style: {
      fill: "#ffd43e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.79,158.88c0,18.55-3.82,23.19-20.75,23.19s-20.75-4.64-20.75-23.19,3.91-23.19,20.75-23.19,20.75,4.56,20.75,23.19ZM471.42,158.88c0,10.25,1.22,12.77,8.62,12.77s8.71-2.52,8.71-12.77-1.22-12.77-8.71-12.77-8.62,2.52-8.62,12.77Z",
    style: {
      fill: "#ffd43e",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M122.53,118.84c-8.8-16.5-16.4-27.1-32-44.3,3-8.5,6-22.2,5.4-26.5-.3-2.1-1.4-3.9-3-5.1-3.5-2.5-8.4-1.6-13.5-.7-3,.6-6.5,1.2-8.5.8-1.5-.3-3.7-1.1-6-1.9-6.9-2.4-14.7-5.1-20.1-2.1-1.6.9-3.8,2.8-4.5,6.5-1.3,6.2,2.9,22,6.7,31.4-2.1,2.4-4.3,4.8-6.6,7.2-8,8.6-16.1,17.3-23.3,29.5-9.6,16.2-12.5,35.2-7.8,50.8,4.2,14,14.4,25.3,29.5,32.6,9.5,4.6,20.3,6.9,31.5,6.9,8.9,0,18.1-1.5,27-4.4,15.4-5.1,26.3-14.5,31.4-27.3,6.1-15.1,3.8-34.6-6.2-53.4ZM49.13,47.44c.1-.3.1-.5.1-.5.3-.2.7-.3,1.3-.3,2.9,0,8.9,2.1,11.4,3,2.6.9,5.1,1.8,7.2,2.2,3.7.7,7.9,0,11.9-.8,1.8-.3,4.5-.8,6-.8-.3,4-2.7,15.6-5.5,22.8-9.5,4.7-21,2.8-25.8,1.6-4.1-9.5-7.2-24.2-6.6-27.2ZM120.43,168.94c-4.2,10.3-12.9,17.8-25.9,22.1-18,5.9-36.9,5.2-51.8-2-12.9-6.2-21.2-15.3-24.8-27.1-4-13.3-1.4-29.6,6.9-43.6,6.7-11.4,14.5-19.7,22.1-27.9,2.4-2.5,4.8-5.2,7.2-7.9,2.9.7,7.7,1.6,13.2,1.6s11.2-.8,16.8-3.4c15,16.6,22.1,26.4,30.5,42.3,8.7,16.5,10.9,33.2,5.8,45.9Z",
    style: {
      fill: "#55c81e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.53,125.04h.2c.1,0,6.3-.2,9.7,4.2,1.3,1.8,3.9,2.1,5.6.7,1.8-1.3,2.1-3.9.7-5.6-5.7-7.4-15-7.4-16.3-7.4-10.6,0-19.8,6.4-23.9,15.5h-6.6c-2.2,0-4,1.8-4,4s1.8,4,4,4h4.4c-.1.9-.2,1.9-.2,2.9s.1,1.9.2,2.9h-4.4c-2.2,0-4,1.8-4,4s1.8,4,4,4h6.6c4.1,9.1,13.3,15.4,23.9,15.5h.5c2,0,8.6-.3,14.1-3.9,1.9-1.2,2.4-3.7,1.2-5.5-1.2-1.9-3.7-2.4-5.5-1.2-4.3,2.8-9.9,2.6-9.9,2.6h-.2c-6,0-11.4-3-14.8-7.5h12.1c2.2,0,4-1.8,4-4s-1.8-4-4-4h-15.5c-.1-.9-.2-1.9-.2-2.9s.1-1.9.2-2.9h15.5c2.2,0,4-1.8,4-4s-1.8-4-4-4h-12.1c3.3-4.5,8.7-7.4,14.7-7.4Z",
    style: {
      fill: "#55c81e",
      strokeWidth: 0
    }
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCrowdvotingFoerdersummenVisualisierungInlineRgb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/crowdvoting-foerdersummen-visualisierung-inline-rgb.8109bd8aa2efbb7bd76eb52956aa0058.svg";